import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateManipulationService } from 'src/app/shared/services/API/pharmacy/template-manipulation.service';
import { TemplateMedicineGroupService } from 'src/app/shared/services/API/pharmacy/template-medicine-grouop.service';
import { TemplateMedicineTypeService } from 'src/app/shared/services/API/pharmacy/template-medicine-type.service';
import { TemplateModel } from 'src/app/shared/services/models/pharmacy/template.model';
import { MedicineTypeTemplateStruct } from 'src/app/shared/services/structs/pharmacy/medicine-type-template.struct';
import { TemplateMedicineGroupTypeStruct } from 'src/app/shared/services/structs/pharmacy/template-medicine-group-type.struct';
import { TemplateGroupDeleteModalComponent } from './template-group-delete-modal/template-group-delete-modal.component';

@Component({
  selector: 'app-template-group',
  templateUrl: './template-group.component.html',
  styleUrls: ['./template-group.component.css']
})
export class TemplateGroupComponent implements OnInit {

  constructor(private templateMedicineGroupService: TemplateMedicineGroupService,
    private alertService: AlertService,
    public dialog: MatDialog,
    private templateManipulationService: TemplateManipulationService,
  ) { }
    
  public menuModuleEnum:MenuModuleEnum = MenuModuleEnum.consulting;
  public menuFunctionalityEnum:MenuFunctionalityEnum = MenuFunctionalityEnum.consulting_template_group;
    
  public listMedicineGroup: TemplateMedicineGroupTypeStruct[];
  public isLoading: boolean;
  public searchText: string;
  public idTemplate: number;
  public listTemplate: TemplateModel[];

  ngOnInit(): void {
    this.isLoading = true;
    this.listAllTemplate();
    this.search();
  }
  search(){
    this.isLoading = true;  
    if(this.searchText == "")
      this.searchText = null;
    
    if(!this.idTemplate)
      this.idTemplate = null;

    this.templateMedicineGroupService.listTemplateMedicineGroup(this.searchText, this.idTemplate).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      this.listMedicineGroup = response.listMedicineGroup;  
    
      this.isLoading = false;    
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;    
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }

  private timeoutKeySearch: any = null;
  
  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search();
      }
    }, 1000);
  }
  
  openModal(idMedicineGroup){
    const dialogRef = this.dialog.open(TemplateGroupDeleteModalComponent, {
      data: {
        idMedicineGroup: idMedicineGroup
      },
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.deleteMedicineGroup){
        this.search();
      }
    });
  }

  listAllTemplate(){
    this.templateManipulationService.listAllTemplate().subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.listTemplate = response.listTemplate;  
    
      this.isLoading = false;    
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;    
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
}